import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _mergeProps({ id: _ctx.id }, _ctx.attributes, {
    class: { required: _ctx.attributes.required, 'no-click': _ctx.attributes.disabled }
  }), _toDisplayString(_ctx.content), 17, _hoisted_1))
}